<template>
  <div class="view home">
    <TitleBlock :data="$store.state.content[$store.state.lang][$store.state.mode][0]" :orientation="'center'" />
    <ImageBlock :data="$store.state.content[$store.state.lang][$store.state.mode][1]" :type="'big'" :first="true" />
    <TextBlock :data="$store.state.content[$store.state.lang][$store.state.mode][2]" :orientation="'right'" />
    <TitleBlock :data="$store.state.content[$store.state.lang][$store.state.mode][3]" :orientation="'left'" />
    <TextBlock :data="$store.state.content[$store.state.lang][$store.state.mode][4]" :orientation="'right'" />
    <ImageBlock :data="$store.state.content[$store.state.lang][$store.state.mode][5]" :type="'half'" />
    <TextBlock :data="$store.state.content[$store.state.lang][$store.state.mode][6]" :orientation="'right'" />
    <MarqueeBlock :data="$store.state.content[$store.state.lang][$store.state.mode][7]" :direction="'left'" />
    <ImagesBlock :data="$store.state.content[$store.state.lang][$store.state.mode][8]" />
    <ImageBlock :data="$store.state.content[$store.state.lang][$store.state.mode][9]" :type="'full'" />
    <ImagesBlock :data="$store.state.content[$store.state.lang][$store.state.mode][10]" />
    <MarqueeBlock :data="$store.state.content[$store.state.lang][$store.state.mode][11]" :direction="'right'" />
    <TitleBlock :data="$store.state.content[$store.state.lang][$store.state.mode][12]" :orientation="'right'" />
    <TextBlock :data="$store.state.content[$store.state.lang][$store.state.mode][13]" :orientation="'left'" />
    <ImageBlock :data="$store.state.content[$store.state.lang][$store.state.mode][14]" :type="'big'" />
    <TitleBlock :data="$store.state.content[$store.state.lang][$store.state.mode][15]" :orientation="'huge'"/>
    <FooterBlock />
  </div>
</template>

<script>
import TitleBlock from '@/components/TitleBlock.vue';
import ImageBlock from '@/components/ImageBlock.vue';
import TextBlock from '@/components/TextBlock.vue';
import MarqueeBlock from '@/components/MarqueeBlock.vue';
import ImagesBlock from '@/components/ImagesBlock.vue';
import FooterBlock from '@/components/FooterBlock.vue';

export default {
  name: 'Home',

  components: {
    TitleBlock,
    ImageBlock,
    TextBlock,
    MarqueeBlock,
    ImagesBlock,
    FooterBlock,
  },
};
</script>

<style lang="scss">
.view {
  padding-top: 150px;

  @include mq($until: ipadL) {
    padding-top: 100px;
  }
}
</style>
